import React, {useState, useEffect, useMemo} from 'react';
import { Button, ScrollView, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import IcomoonIcon from '../../../../components/IcomoonIcon';
import { Icon } from '../../../../components/Icon';
import Header from '../../../../navigation/Header';
import api from '../../../../utils/api';
import useActiveResidentCommunity from '../../../../hooks/useActiveResidentCommunity';
import { useQuery } from '@tanstack/react-query';
import { useNavigation } from '@react-navigation/native';
import { Image } from 'expo-image';


export function ResidentUnitFeeRow({ unitFee, unitId }) {
  const navigation = useNavigation()
  const { community, communityId } = useActiveResidentCommunity()

  const goToFeeDetail = () => navigation.navigate('Resident.Fees.Detail', { 
    unit_fee_id: unitFee.uuid,
    unitId,
  })

  const isMainFee = unitFee.fee?.type?.type === 'main'

  return (
    <TouchableOpacity style={tw`border-b border-gray-200 px-3 py-2`} onPress={goToFeeDetail}>
      <View style={tw`row`}>
        {
          isMainFee ?
            <Icon name="calendario" size={26} />
            :
            <Icon name="cuota" size={28} />
        }

        <View style={tw`ml-4 flex-1`}>
          <Text style={tw.style(`text-gray-600 font-500 text-base mt-1.4 leading-1.1`, isMainFee && `text-secondary`)}>{unitFee.fee?.name}</Text>

          <View style={tw`row`}>
            <Text style={tw.style(`text-base font-500`, unitFee.is_paid ? `text-primary` : `text-red-500`)}>${unitFee.is_paid ? unitFee.paid : unitFee.pending}</Text>

            {/* community?.settings?.resident_can_pay_fees && */}
            <Text style={tw.style(`text-base ml-2`, unitFee.is_paid ? `text-primary` : `text-red-400`)}>{unitFee.is_paid ? "Pagado" : "por pagar"}</Text>
          </View>

        </View>

        <IcomoonIcon name='chevron-right' color={tw.color('secondary')} style={tw`ml-2 -mt-1`} />
      </View>


    </TouchableOpacity>
  )
}


export default function ResidentUnitFeesScreen({navigation, route}) {
  const { unitId } = route.params
  const { community, communityId } = useActiveResidentCommunity()

  // const { isLoading, error, data, refetch } = useQuery({
  //   queryKey: ['unit.fees.balance', communityId, unitId],
  //   queryFn: () => api.get(`/communities/${communityId}/units/${unitId}/fees/balance`).then(response => response.data),
  // })

  const { isLoading, error, data:unitFees, refetch } = useQuery({
    queryKey: ['unit.fees', communityId, unitId],
    queryFn: () => api.get(`/communities/${communityId}/units/${unitId}/fees`).then(response => response.data),
  })


  const pendingUnitFees = useMemo(() => {
    return unitFees?.filter(fee => !fee.is_paid)
  }, [unitFees])

  const paidUnitFees = useMemo(() => {
    return unitFees?.filter(fee => fee.is_paid)
  }, [unitFees])
  

  return (
    <View style={tw`flex-1`}>
      <Header style={tw`bg-secondary rounded-b-0 mb-0`} showBackButton backButtonColor='white'>
        <View style={tw``}>
          <Text style={tw`text-white`}>Historial de cuotas</Text>
          {
            isLoading ? 
              <Text style={tw`text-white/50`}>Cargando...</Text>
            :
              <Text style={tw`text-white/80`}>{pendingUnitFees?.length} cuotas por pagar</Text>
          }
        </View>
      </Header>

      <ScrollView style={tw`flex-1`} contentContainerStyle={tw`py-4 px-2`}>
        {
          pendingUnitFees?.length > 0 &&
            <View style={tw`mb-6`}>
              <View style={tw`bg-gray-200 mb-4 self-center px-6 py-0.5 rounded-full border border-gray-300`}>
                <Text style={tw`text-gray-400`}>Pendientes de pago</Text>
              </View>

              <View style={tw`border border-gray-200 rounded-2xl`}>
                {
                  pendingUnitFees?.map(unitFee => 
                    <ResidentUnitFeeRow unitId={unitId} key={unitFee.uuid} unitFee={unitFee} />
                  )
                }
              </View>
            </View>
        }

        {
          paidUnitFees?.length > 0 &&
            <>
            <View style={tw`bg-gray-200 mb-2 self-center px-6 py-0.5 rounded-full border border-gray-300`}>
                <Text style={tw`text-gray-400`}>Pagados</Text>
              </View>

              {
                paidUnitFees?.map(unitFee => 
                  <ResidentUnitFeeRow unitId={unitId} key={unitFee.uuid} unitFee={unitFee} />
                )
              }
            </>
        }

      </ScrollView>      

    </View>
  );
}
